//API
import { getRequest, putRequest, postRequest } from "../globalService"

const endPoint = 'client';


export const getClients = (coachId, filter = { direction: 'asc', items: 10})=> {

    return postRequest(`${endPoint}/coach/${coachId}`, filter, true)
}

export const getActiveClients = (coachId, filter = { direction: 'asc', items: 10})=> {

    return postRequest(`${endPoint}/coach/${coachId}/active`, filter, true)
}


export const getclient = (clientId)=> {
    return getRequest(`${endPoint}/${clientId}`,true)
}

export const updateClient = (clientId, body = {})=> {
    return putRequest(`${endPoint}/${clientId}`, body, true)
}

export const getClientsByCoach = (coachId, body = {})=> {
    return postRequest(`${endPoint}/coach/${coachId}`, body, true)
}

export const getAllClientsByCoach = (coachId, body = {})=> {
    return postRequest(`${endPoint}/all/coach/${coachId}`, body, true)
}


export const resendInvitation = (clientId, body={})=> {
    return putRequest(`${endPoint}/${clientId}/resendinvitation`, body, true)
}
